@defer (when propertyViewModel) {
  <div class="main-container" #labelledContainer
    [class.full-width]="isFullWidth">
    <div class="label-container" [class.full-width]="isFullWidth">
      <nts-label-box [isRequired]="showLabelRequired ? propertyViewModel.isRequired : false"
        [title]="propertyViewModel.metadataDescription$ | async"
        [label]="propertyViewModel.metadataShortDescription$ | async"
        [labelId]="labelId"></nts-label-box>
    </div>

    <div class="edit-container">
      @if(isNumeric) {
        <nts-numeric-text-box
          [isDisabled]="isDisabled"
          [customCommandsName]="customCommandsName"
          [propertyViewModel]="numericPropertyViewModel"
          [tabIndex]="tabIndex"
          (viewReady)="viewReadyCheck()"
          [updateOnBlur]="!propertyViewModel.instantModelChange">
        </nts-numeric-text-box>
      }

      @if(isEnum) {
        <nts-enum-text-box
          [isDisabled]="isDisabled"
          [multiselect]="enumPropertyViewModel.multiselect"
          [chipsOptions]="chipsOptions"
          [customCommandsName]="customCommandsName"
          [appendTo]="appendToBody ? 'body': null"
          [propertyViewModel]="enumPropertyViewModel"
          [options]="enumOptions"
          [tabIndex]="tabIndex"
          (viewReady)="viewReadyCheck()">
        </nts-enum-text-box>
      }

      @if(isRadio) {
        <nts-radio-button-text-box
          [isDisabled]="isDisabled"
          [propertyViewModel]="enumPropertyViewModel"
          (viewReady)="viewReadyCheck()"
          [tabIndex]="tabIndex">
        </nts-radio-button-text-box>
      }

      @if(isBool && useToggle) {
        <nts-toggle-text-box
          [isDisabled]="isDisabled"
          [propertyViewModel]="propertyViewModel"
          (viewReady)="viewReadyCheck()"
          [tabIndex]="tabIndex">
        </nts-toggle-text-box>
      }

      @if(isBool && !useToggle) {
        <nts-checkbox-text-box
          [isDisabled]="isDisabled"
          [propertyViewModel]="propertyViewModel"
          (viewReady)="viewReadyCheck()"
          [tabIndex]="tabIndex">
        </nts-checkbox-text-box>
      }

      @if(isDate) {
        <nts-date-text-box
          [isDisabled]="isDisabled"
          [customCommandsName]="customCommandsName"
          [propertyViewModel]="datePropertyViewModel"
          [appendTo]="appendToBody ? 'body': labelledContainer"
          (viewReady)="viewReadyCheck()"
          [tabIndex]="tabIndex">
        </nts-date-text-box>
      }

      @if(isFile) {
        <nts-file-text-box
          [isDisabled]="isDisabled"
          [propertyViewModel]="filePropertyViewModel"
          [tabIndex]="tabIndex"
          (viewReady)="viewReadyCheck()"
          [updateOnBlur]="!propertyViewModel.instantModelChange">
        </nts-file-text-box>
      }

      @if(isString) {
        <nts-string-text-box
          [style.height]="multiline ? '100%' : null"
          [isDisabled]="isDisabled"
          [useChips]="useChips"
          [chipsOptions]="chipsOptions"
          [customCommandsName]="customCommandsName"
          [multiline]="multiline"
          [appendTo]="appendToBody ? 'body': null"
          [propertyViewModel]="stringPropertyViewModel"
          [tabIndex]="tabIndex"
          (viewReady)="viewReadyCheck()"
          [updateOnBlur]="!propertyViewModel.instantModelChange">
        </nts-string-text-box>
      }

      @if(isTimeSpan) {
        <nts-time-span-text-box
          [isDisabled]="isDisabled"
          [customCommandsName]="customCommandsName"
          [propertyViewModel]="timeSpanPropertyViewModel"
          (viewReady)="viewReadyCheck()"
          [tabIndex]="tabIndex">
        </nts-time-span-text-box>
      }

      @if(isGuid) {
        <nts-string-text-box
          [isDisabled]="isDisabled"
          [customCommandsName]="customCommandsName"
          [propertyViewModel]="stringPropertyViewModel"
          [tabIndex]="tabIndex"
          (viewReady)="viewReadyCheck()"
          [updateOnBlur]="!propertyViewModel.instantModelChange">
        </nts-string-text-box>
      }

      @if(isDateTimeOffset) {
        <nts-date-offset-text-box
          [isDisabled]="isDisabled"
          [customCommandsName]="customCommandsName"
          [propertyViewModel]="dateTimeOffsetPropertyViewModel"
          [appendTo]="appendToBody ? 'body': labelledContainer"
          (viewReady)="viewReadyCheck()"
          [tabIndex]="tabIndex"
          [updateOnBlur]="!propertyViewModel.instantModelChange">
        </nts-date-offset-text-box>
      }

      @if(isOffset) {
        <nts-enum-text-box
          [isDisabled]="isDisabled"
          [customCommandsName]="customCommandsName"
          [appendTo]="appendToBody ? 'body': null"
          [propertyViewModel]="enumPropertyViewModel"
          [options]="enumOptions"
          (viewReady)="viewReadyCheck()"
          [tabIndex]="tabIndex">
        </nts-enum-text-box>
      }
    </div>
  </div>
} @placeholder {
  @if (!loadingError) {
    <div class="loading-container">
      <div class="loading-spinner">
        <div class="spinner"></div>
      </div>
      <div class="loading-text">Caricamento componente...</div>
    </div>
  }
}

@if (loadingError) {
  <div class="error-container">
    <div class="error-message">
      <p>{{ loadingError?.description || 'Impossibile caricare il componente.' }}</p>
    </div>
  </div>
}